import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { User } from '../../models/User';
import { SevaData } from '../../models/SevaData';
import { Login } from '../../models/Login';
import { PostLogin } from '../../models/PostLogin';
import { PostSevaBooking } from '../../models/PostSevaBooking';
import { SevaBookingResponse } from '../../models/SevaBookingResponse';
import { ReportList } from '../../models/Reportlist';
import { RequestOptions } from '@angular/http';
import { Calender } from '../../models/Calander';
import { Event } from '../../models/Event';
import { Seva } from '../../models/Seva';
import { DeleteReport } from '../../models/deletereport';
import { Voucher } from '../../models/voucher';
import { RecurringSevas } from '../../models/recurringsevas';
import { ShashwathaSeva } from '../../models/shashwathaSeva';
import { RecurringList } from '../../models/recurringlist';
import { ExpenseType } from '../../models/expesetye';
import { Japa } from '../../models/japa';
import { JapaReportInput } from '../../models/japareportinput';




/*
  Generated class for the RestProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RestProvider {
  serverURL: string = "https://esevaapi.qubesw.com/api/";
  // serverURL: string = "https://api.srmsn.app/api/";
  //serverURL: string = "http://test.qubesw.com/api/";
  // serverURL: string = "https://srmapi.qubesw.com/api/";
  //serverURL: string = "http://192.168.0.108:8000/api/";

  //Used for local testing
  // serverURL: string = "http://localhost:8000/api/";

  constructor(public httpClient: HttpClient) {
    // console.log('Hello RestProvider Provider');
  }

  public searchUser(phone: string): Observable<User[]> {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient
      .get(this.serverURL + 'user/' + phone, { headers })
      .map(res => <User[]>res['data'])
      .catch((err) => {
        console.error(err);
        return Observable.throw(err.statusText);
      });
  }

  public getSevacategory() {
    return this.httpClient
      .get(this.serverURL + 'sevacategory')
      // .map(res => <SevaData>res['data'])
      // .catch((err) => {
      //     console.error(err);
      //     return Observable.throw(err.statusText);
      // });
      .map(
        (data: any) => {
          // console.log("in getMaturity", data);
          return <any>data;
        },
        error => {
          //console.error();
          console.log(error.statusText);
        }

      );
  }
  public getSevaData(): Observable<SevaData> {
    return this.httpClient
      .get(this.serverURL + 'sevadata')
      // .map(res => <SevaData>res['data'])
      // .catch((err) => {
      //     console.error(err);
      //     return Observable.throw(err.statusText);
      // });
      .map(
        (data: SevaData) => {
          // console.log("in getMaturity", data);
          return <SevaData>data;
        },
        error => {
          //console.error();
          console.log(error.statusText);
        }

      );
  }
  public getSevas(id: number): Observable<Seva[]> {

    return this.httpClient
      .get(this.serverURL + 'seva/' + id)
      // .map(res => <SevaData>res['data'])
      // .catch((err) => {
      //     console.error(err);
      //     return Observable.throw(err.statusText);
      // });
      .map(
        (data: Seva[]) => {
          // console.log("in getMaturity", data);
          return <Seva[]>data;
          //return data;
        },
        error => {
          //console.error();
          console.log(error.statusText);
        }

      );
  }
  // public getSevaDetail(id:number,param?:Seva): Observable<Seva> {
  public getSevaDetail(id: number, param?: Seva): any {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient
      .get(this.serverURL + 'sevadetail/' + id, { headers: headers })
      // .map(res => <SevaData>res['data'])
      // .catch((err) => {
      //     console.error(err);
      //     return Observable.throw(err.statusText);
      // });
      .map(
        (data: any) => {
          // console.log("in getMaturity", data);
          //return <Seva>data;
          return data;
        },
        error => {
          //console.error();
          console.log(error.statusText);
        }

      );
  }
  public postSevaDetail(param: Seva): any {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    console.log(this.serverURL + 'seva', param, { headers: headers })
    return this.httpClient
      .post(this.serverURL + 'seva', param, { headers: headers })
      // .map(res => <SevaData>res['data'])
      // .catch((err) => {
      //     console.error(err);
      //     return Observable.throw(err.statusText);
      // });
      .map(
        (data: any) => {
          // console.log("in getMaturity", data);
          return data;
          //return data;
        },
        error => {
          //console.error();
          console.log(error.statusText);
        }

      );
  }
  // public postLogin(login: Login): Observable<String> {
  //   return this.httpClient
  //     .post(this.serverURL + 'login', login)
  //     .map(
  //       (data) => {
  //         console.log("in login", data);
  //         return data.toString();
  //       },
  //       error => {
  //         //console.error();
  //         console.log(error.statusText);
  //       }
  //     );
  // }
  public postLogin(login: Login): Observable<PostLogin> {
    // console.log("login data", login);
    return this.httpClient
      .post(this.serverURL + 'login_user', login)
      .map(
        (res) => {
          console.log("in login data", res);
          let postLogin = <PostLogin>res["data"];
          let token = postLogin["token"];
          let user = postLogin["user"];
          let categories = JSON.stringify(postLogin["sevacategory"])
          console.log("token in login ", token);
          localStorage.setItem('token', token);
          // var tokenget = localStorage.getItem('token')
          // console.log("tokenget: for Authorization", tokenget)
          localStorage.setItem("srm_user", JSON.stringify(user)); //It's saved!
          localStorage.setItem("seva_categories", categories);

          // var test = localStorage.getItem("test"); //Let's grab it and save it to a variable
          // console.log("testsdadasdad", test); //Logs "Hello World!"

          return postLogin;
        },
        error => {
          //console.error();
          console.log(error.statusText);
        }
      );
  }


  public postSevaBooking(postSevaBookingParam: PostSevaBooking): Observable<SevaBookingResponse> {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

    return this.httpClient
      .post(this.serverURL + 'sevabooking', postSevaBookingParam, { headers: headers })
      .map(
        (data) => {
          console.log("in postSevaBooking", data);
          return <SevaBookingResponse>data;
        },
        error => {
          console.log(error);
          console.log(error.statusText);
        }
      );
  }

  downloadPDF(receitid: string): any {

    //     return this.httpClient.get("http://sa.qubesw.com/api/quote/1285",
    //         {responseType: 'blob'}
    //       );

    // var urlforreceipt = 'http://srmdev.qubesw.com/api/receipt/'+receitid
    var urlforreceipt = this.serverURL + "receipt/" + receitid
    return this.httpClient.get(urlforreceipt, { responseType: 'blob' }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }


  reprintPDF(receiptid: string): any {
    // var urlforreceipt = this.serverURL + "printreceipt/" + receiptid
    let modReceiptId = receiptid.replace('/', '_').replace('/', '_');
    var urlforreceipt = this.serverURL + "printreceipt/" + modReceiptId
    return this.httpClient.get(urlforreceipt, { responseType: 'blob' }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }



  reprintVoucherPDF(receiptid: string): any {
    // var urlforreceipt = this.serverURL + "printreceipt/" + receiptid
    let modReceiptId = receiptid.replace('/', '_').replace('/', '_');
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlforreceipt = this.serverURL + "voucher/" + modReceiptId
    return this.httpClient.get(urlforreceipt, { responseType: 'blob', headers: headers }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  //function for retrieving single day seva report pdf
  reprintDaySevaReport(specificDate: any, id?: number) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlfordaysevareport = this.serverURL + "dailysevabooking" + "?start_date=" + specificDate + "&seva_id=" + id
    return this.httpClient.get(urlfordaysevareport, { responseType: 'blob', headers: headers }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  //function for retrieving single day seva report pdf
  reprintDayJapaReport(japareportparam: JapaReportInput) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlfordayjapareport = this.serverURL + "getjapareport"
    return this.httpClient.post(urlfordayjapareport, japareportparam, { responseType: "blob", headers: headers }).map(
      (res: any) => {
        console.log("res file", res);
        if (japareportparam.report_type == "pdf") {
          return new Blob([res], { type: 'application/pdf', });
        }
        else {
          return res;
        }

      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  reprintDayJapaCSV(japareportparam: JapaReportInput) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlfordayjapareport = this.serverURL + "getjapareport"
    return this.httpClient.post(urlfordayjapareport, japareportparam, { headers: headers }).map(
      (res: any) => {
        console.log("res file", res);

        return res;


      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  //function for finantial summary pdf retrival
  reprintFinancialSummary(startdate: any, enddate: any) {
    // var urlfordaysevareport = this.serverURL + "finsummary?" + "start_date=" + startdate + "&end_date=" + enddate;
    var urlfordaysevareport = this.serverURL + "allfinreport?" + "start_date=" + startdate + "&end_date=" + enddate;
    return this.httpClient.get(urlfordaysevareport, { responseType: 'blob' }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  //function for seva pdf retrival
  reprintFinancialSevaSummary(startdate: any, enddate: any) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

    var urlfordaysevareport = this.serverURL + "detailfinreport?" + "start_date=" + startdate + "&end_date=" + enddate;
    return this.httpClient.get(urlfordaysevareport, { responseType: 'blob', headers: headers }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  //function for building fund pdf retrival
  reprintFinancialBuildingSummary(startdate: any, enddate: any) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

    var urlfordaysevareport = this.serverURL + "bldgfinreport?" + "start_date=" + startdate + "&end_date=" + enddate;
    return this.httpClient.get(urlfordaysevareport, { responseType: 'blob', headers: headers }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  //function for building fund pdf retrival
  reprintFinancialPratishtapanaSummary(startdate: any, enddate: any) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

    var urlfordaysevareport = this.serverURL + "pfinreport?" + "start_date=" + startdate + "&end_date=" + enddate;
    return this.httpClient.get(urlfordaysevareport, { responseType: 'blob', headers: headers }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  //function for building fund pdf retrival
  reprintFinancialSilverJubileeSummary(startdate: any, enddate: any) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

    var urlfordaysevareport = this.serverURL + "sjfinreport?" + "start_date=" + startdate + "&end_date=" + enddate;
    return this.httpClient.get(urlfordaysevareport, { responseType: 'blob', headers: headers }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }


  //function for vouchers pdf retrival
  reprintFinancialVouchersSummary(startdate: any, enddate: any) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

    var urlfordayvoucherreport = this.serverURL + "voucherreport?" + "start_date=" + startdate + "&end_date=" + enddate;
    return this.httpClient.get(urlfordayvoucherreport, { responseType: 'blob', headers: headers }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }
  //function for aradhane pdf retrival
  reprintFinancialAradhaneSummary(startdate: any, enddate: any) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + token)
      .set("timeout", "`${120000}");

    var urlfordaysevareport = this.serverURL + "aradhanafinreport?" + "start_date=" + startdate + "&end_date=" + enddate;
    return this.httpClient.get(urlfordaysevareport, { responseType: 'blob', headers: headers }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  reprintFinancialAllSummary(startdate: any, enddate: any) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

    var urlfordaysevareport = this.serverURL + "allfinreport?" + "start_date=" + startdate + "&end_date=" + enddate;
    return this.httpClient.get(urlfordaysevareport, { responseType: 'blob', headers: headers }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  //RETRIVING SPECIFIC DAY'S SEVA LIST
  getSevasOfTheDay(start_date) {
    return this.httpClient
      .get(this.serverURL + "daysevalist?start_date=" + start_date)
      .map(
        (data: Seva[]) => {
          return <Seva[]>data;
          //return data;
        },
        error => {
          //console.error();
          console.log(error);
        }

      );

  }
  // SEVA CSV
  sevacsvReport(start_date: string): any {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlforreceipt = this.serverURL + "report?start_date=" + start_date;
    return this.httpClient.get(urlforreceipt, { headers: headers }).map(
      (res) => {
        console.log("res file", res);
        // return new Blob([res], { type: 'application/pdf', });
        //return new Blob([res], { type: 'text/csv', });
        return res;
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }
  //FINANCIAL REGULAR CSV
  financialRegularcsvReport(start_date: string, end_date: string): any {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlforreceipt = this.serverURL + "detailcsvreport?start_date=" + start_date + "&end_date=" + end_date;
    return this.httpClient.get(urlforreceipt, { headers: headers }).map(
      (res) => {
        console.log("res file", res);
        // return new Blob([res], { type: 'application/pdf', });
        //return new Blob([res], { type: 'text/csv', });
        return res;
      },
      error => {
        //console.error();
        console.log("error", error);
      }
    );
  }

  //FINANCIAL BUILDING FUND CSV
  financialBuildingcsvReport(start_date: string, end_date: string): any {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlforreceipt = this.serverURL + "bldgcsvreport?start_date=" + start_date + "&end_date=" + end_date;
    return this.httpClient.get(urlforreceipt, { headers: headers }).map(
      (res) => {
        console.log("res file", res);
        // return new Blob([res], { type: 'application/pdf', });
        //return new Blob([res], { type: 'text/csv', });
        return res;
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  //FINANCIAL ARADHANE CSV
  financialAradhanecsvReport(start_date: string, end_date: string): any {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlforreceipt = this.serverURL + "aradhanacsvreport?start_date=" + start_date + "&end_date=" + end_date;
    return this.httpClient.get(urlforreceipt, { headers: headers }).map(
      (res) => {
        console.log("res file", res);
        // return new Blob([res], { type: 'application/pdf', });
        //return new Blob([res], { type: 'text/csv', });
        return res;
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  //FINANCIAL VOUCHERS CSV
  financialVoucherscsvReport(start_date: string, end_date: string): any {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlforreceipt = this.serverURL + "vouchercsv?start_date=" + start_date + "&end_date=" + end_date;
    return this.httpClient.get(urlforreceipt, { headers: headers }).map(
      (res) => {
        console.log("res file", res);
        // return new Blob([res], { type: 'application/pdf', });
        //return new Blob([res], { type: 'text/csv', });
        return res;
      },
      error => {
        //console.error();
        console.log(error);
      }
    );
  }
  //FINANCIAL VOUCHERS CSV
  financialPratishtapanacsvReport(start_date: string, end_date: string): any {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlforreceipt = this.serverURL + "pcsvreport?start_date=" + start_date + "&end_date=" + end_date;
    return this.httpClient.get(urlforreceipt, { headers: headers }).map(
      (res) => {
        console.log("res file", res);
        // return new Blob([res], { type: 'application/pdf', });
        //return new Blob([res], { type: 'text/csv', });
        return res['data'];
      },
      error => {
        //console.error();
        console.log(error);
      }
    );
  }

  //FINANCIAL REGULAR CSV
  JapacsvReport(start_date: string, end_date: string): any {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlforreceipt = this.serverURL + "detailcsvreport?start_date=" + start_date + "&end_date=" + end_date;
    return this.httpClient.get(urlforreceipt, { headers: headers }).map(
      (res) => {
        console.log("res file", res);
        // return new Blob([res], { type: 'application/pdf', });
        //return new Blob([res], { type: 'text/csv', });
        return res;
      },
      error => {
        //console.error();
        console.log("error", error);
      }
    );
  }

  //SEVA CSV retrival
  csvReport(start_date: string, end_date: string, id: number): any {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlforreceipt = this.serverURL + "report?start_date=" + start_date + "&end_date=" + end_date + "&seva_id=" + id;
    return this.httpClient.get(urlforreceipt, { headers: headers }).map(
      (res) => {
        console.log("res file", res);
        // return new Blob([res], { type: 'application/pdf', });
        //return new Blob([res], { type: 'text/csv', });
        return res;
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  // public getDailyReport(start_date: string, end_date:string): Observable<SevaBookingResponse> {
  //   var token = localStorage.getItem('token')
  //   //const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
  //   const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
  //   var urlforreceipt = this.serverURL + "report?start_date=" + start_date + "&end_date="+ end_date;
  //   return this.httpClient.get(urlforreceipt,  headers ).map(
  //   (res) => {
  //     console.log("res file", res);
  //     // return new Blob([res], { type: 'application/pdf', });
  //     return new Blob([res], { type: 'text/csv', });
  //   },
  //   error => {
  //     //console.error();
  //     console.log(error.statusText);
  //   }
  // );

  // }
  public getDailyReport(start_date: string, end_date: string): Observable<ReportList> {
    let opt: RequestOptions

    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);


    var urlforreceipt = this.serverURL + "report?start_date=" + start_date + "&end_date=" + end_date;
    return this.httpClient
      .get(urlforreceipt, { headers: headers })
      .map(
        (res) => {
          console.log("res file", res);
          //     // return new Blob([res], { type: 'application/pdf', });
          //return new Blob([res], { type: 'text/csv', });
          return <ReportList>res
        },
        error => {
          //console.error();
          console.log(error.statusText);
        }
      );
  }

  getReportDetails(receipt_number: string): Observable<SevaBookingResponse> {
    var urlforreceipt = this.serverURL + "getreceipt/" + receipt_number;
    return this.httpClient.get(urlforreceipt)
      .map(
        (res: SevaBookingResponse) => {
          return <SevaBookingResponse>res['data'];
        },
        error => {
          console.log(error.statusText);
        }
      );
  }

  deleteReciept(id: number): any {

    var urlforreceipt = this.serverURL + "sevabooking/" + id;
    return this.httpClient.delete(urlforreceipt).map(
      resp => {
        console.log('deleted')
        return resp;
      },
      error => {
        console.log('error occur, delete fail')
        console.log(error);
      }

    );

  }
  DeleteSevaBooking(deleteparam: DeleteReport) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    var urlforreceipt = this.serverURL + "deletesevabooking";
    return this.httpClient.post(urlforreceipt, deleteparam, { headers: headers }).map(
      resp => {
        console.log('deleted resp:', resp)
        return resp;
      },
      error => {
        console.log('error occur, delete fail')
        console.log(error);
      }

    );
  }
  ShowDeletedReports(startdate: any, enddate: any) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

    var urlfordaysevareport = this.serverURL + "deletedreceipt?" + "start_date=" + startdate + "&end_date=" + enddate;
    return this.httpClient.get(urlfordaysevareport, { responseType: 'blob', headers: headers }).map(
      (res) => {
        console.log("res file", res);
        return new Blob([res], { type: 'application/pdf', });
      },
      error => {
        //console.error();
        console.log(error.statusText);
      }
    );
  }

  //  //writing method for getting calander data
  // getCalanderData(yearmonthdate)
  getCalanderData(matha, yearmonthdate)
  //getCalanderData()
  {
    var urlforcalander = this.serverURL + "monthcalendar?" + "matha=" + matha + "&date=" + yearmonthdate;
    //var urlforcalander = this.serverURL + "calendar";
    return this.httpClient.get(urlforcalander)
      .map(
        (res: Calender[]) => {
          return <Calender[]>res['data'];
        },
        error => {
          console.log(error.statusText);
        }
      );
  }

  getEvents(param: any) {
    var urlforevent = this.serverURL + "monthlyevents/" + param;
    var token = localStorage.getItem('token');
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient.get(urlforevent, { headers: headers })
      .map(
        (res: Event[]) => {
          return <Event[]>res['data'];
        },
        error => {
          console.log(error.statusText);
        }
      );
  }
  postEvent(EventParam: Event) {
    var urlforevent = this.serverURL + "event";
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient.post(urlforevent, EventParam, { headers: headers })
      .map(
        (res: any) => {
          return res;
        },
        error => {
          console.log(error.statusText);
          console.log(error)
        }
      );
  }
  deleteEvent(id: number): any {

    var urlforevent = this.serverURL + "event/" + id;
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient.delete(urlforevent, { headers: headers }).map(
      resp => {
        console.log('deleted')
        return resp;
      },
      error => {
        console.log('error occur, delete fail')
        console.log(error);
      }

    );

  }
  //update user
  updateUser(userparam: User) {
    var urlforupdateuser = this.serverURL + "user"
    console.log(urlforupdateuser);
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient.post(urlforupdateuser, userparam, { headers: headers })
      .map(
        (res: User[]) => {
          return <User[]>res['data'];
        },
        error => {
          console.log(error.statusText);
        }
      );
  }

  //save/update Japa
  updateJapa(japaparam: Japa) {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

    var urlforupdatejapa = this.serverURL + "japa"
    console.log(urlforupdatejapa);
    return this.httpClient.post(urlforupdatejapa, japaparam, { headers: headers })
      .map(
        (res: Japa[]) => {
          console.log("result from api", res)
          return <Japa[]>res;
        },
        error => {
          console.log(error.statusText);
        }
      );
  }

  //GET ALL JAPAS
  ShowAllJapasForAdmin() {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

    return this.httpClient
      .get(this.serverURL + 'japa', { headers: headers })
      .map(res => {
        return res
      })

      .catch((err) => {
        console.error(err);
        return Observable.throw(err.statusText);
      });
  }

  //GET ACTIVE JAPAS
  ShowAllActiveJapas() {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

    return this.httpClient
      .get(this.serverURL + 'japa', { headers: headers })
      .map(res => {
        return res
      })

      .catch((err) => {
        console.error(err);
        return Observable.throw(err.statusText);
      });
  }

  //updating existing reciept pdf
  updateReceipt(receipt_number: any, param: SevaBookingResponse) {
    var urlforreceipt = this.serverURL + "getreceipt/" + receipt_number;
    return this.httpClient.post(urlforreceipt, param)
      .map(
        (res: SevaBookingResponse) => {
          return <SevaBookingResponse>res['data'];
          //return new Blob([res], { type: 'application/pdf', });

        },
        error => {
          console.log(error.statusText);
        }
      )

  }
  ShowAllUsersForAdmin() {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient
      .get(this.serverURL + 'adminusers', { headers: headers })
      .map(res => <User[]>res['data'])

      .catch((err) => {
        console.error(err);
        return Observable.throw(err.statusText);
      });
  }

  //get expenditure type
  public getExpenditureType(): Observable<ExpenseType[]> {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient
      .get(this.serverURL + 'voucher', { headers })
      .map(res => <ExpenseType[]>res,
        // console.log("expense type in rest:",res)
      )
      .catch((err) => {
        console.error(err);
        return Observable.throw(err.statusText);
      });
  }
  // downloadPDF(receitid: string): any {

  //   //     return this.httpClient.get("http://sa.qubesw.com/api/quote/1285",
  //   //         {responseType: 'blob'}
  //   //       );

  //   // var urlforreceipt = 'http://srmdev.qubesw.com/api/receipt/'+receitid
  //   var urlforreceipt = this.serverURL + "receipt/" + receitid
  //   return this.httpClient.get(urlforreceipt, { responseType: 'blob' }).map(
  //     (res) => {
  //       console.log("res file", res);
  //       return new Blob([res], { type: 'application/pdf', });
  //     },
  //     error => {
  //       //console.error();
  //       console.log(error.statusText);
  //     }
  //   );
  // }
  //post voucher
  postVoucher(voucherparam: Voucher) {
    console.log("voucher array in rest: ", voucherparam);
    var urlforupdateuser = this.serverURL + "voucher"
    console.log('postVoucher', urlforupdateuser, voucherparam);
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient.post(urlforupdateuser, voucherparam, { responseType: 'blob', headers: headers })
      .map(
        (res: any) => {
          console.log("result from confirm bill rest", res);
          // return res;
          return new Blob([res], { type: 'application/pdf', });
        },
        error => {
          console.log(error.statusText);
        }
      );
  }

  //GETTING RECURING SEVAS
  public getRecurringSevas(): Observable<RecurringSevas> {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient
      .get(this.serverURL + 'recurringsevas', { headers })
      .map(res => {
        return res;
      }
      )
      .catch((err) => {
        console.error(err);
        return Observable.throw("error", err);
      });
  }

  //SHASHWATHA SEVA BOOKING POST
  postShashwathaBooking(sevaparam: ShashwathaSeva): Observable<ShashwathaSeva> {
    var urlforshashwathabooking = this.serverURL + "recurringsevas"
    console.log(urlforshashwathabooking);
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient.post(urlforshashwathabooking, sevaparam, { headers: headers })
      .map(
        (res: ShashwathaSeva) => {
          return res;
        },
        error => {
          console.log(error.statusText);
        }
      );
  }

  getShashwathaSevaReipt(id: any) {
    var urlforshashwathareceipt = this.serverURL + "recurringsevas/"
    console.log('postVoucher', urlforshashwathareceipt + id);
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient.get(urlforshashwathareceipt + id, { responseType: 'blob', headers: headers })
      .map(
        (res: any) => {
          console.log("result from confirm bill rest", res);
          // return res;
          return new Blob([res], { type: 'application/pdf', });
        },
        error => {
          console.log(error.statusText);
        }
      );
  }

  //RETRIVING SHASHWATHA SEVA USERS
  public getShashwathaSevaUsers(): Observable<RecurringList[]> {
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient
      .get(this.serverURL + 'recurringsevaslist', { headers: headers })
      .map(
        (data: RecurringList[]) => {
          return <RecurringList[]>data['data'];
        },
        error => {
          //console.error();
          console.log(error.statusText);
        }

      );
  }

  postShashwathaUsersStatus(sevaparam: any): any {
    var urlforshashwathabooking = this.serverURL + "updaterecurringsevaslist"
    console.log(urlforshashwathabooking);
    var token = localStorage.getItem('token')
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);
    return this.httpClient.post(urlforshashwathabooking, sevaparam, { headers: headers })
      .map(
        (res: any) => {
          return res;
        },
        error => {
          console.log(error.statusText);
        }
      );
  }
  public getrecurringsevabookings(): Observable<any> {

    return this.httpClient
      .get(this.serverURL + 'genrecurringsevabookings')
      .map(
        (data) => {
          return data;
        },
        error => {
          //console.error();
          console.log(error.statusText);
        }

      );
  }

  // GetSevaCategories()
  // {
  //   return this.httpClient
  //   .get(this.serverURL + 'sevacategory')
  //    .map(res => <User[]>res['data'])

  //   .catch((err) => {
  //     console.error(err);
  //     return Observable.throw(err.statusText);
  //   });
  //  }
}


  // downloadPDF(): any {
  //   return this.httpClient.get('http://sa.qubesw.com/api/quote/1285', { responseType: 'blob' as 'json' })
  //           .map(res => {
  //           return new Blob([res], { type: 'application/pdf', });
  //       });
  //     }

  // downloadPDF(): any {
  //   return this.httpClient.get('http://sa.qubesw.com/api/quote/1285', { responseType: 'blob'})
  //           .map(res => {
  //           return new Blob([res], { type: 'application/pdf', });
  //       });
  // }

  // public downloadPDF(): any {
  //   return this.httpClient.get('http://sa.qubesw.com/api/quote/1285', { responseType: 'blob' }).map(
  //   (res) => {
  //         return new Blob([res], { type: 'application/pdf' });
  //           //return new Blob([res.blob()], { type: 'application/pdf' })
  //       });
  //     }


  // getreport() {
  //   return this.httpClient.get('http://sa.qubesw.com/api/quote/1285', { responseType: 'blob' }).map(
  //   (res) => {
  //           console.log(res)

  //           return new Blob([res], { type: 'application/pdf' });
  //       });
  //     }

  //   public getreport() {


  //     return this.httpClient.get("http://sa.qubesw.com/api/quote/1285",
  //         {responseType: 'blob'}
  //       );
  // }

  // public postSevaBooking(postSevaBookingParam: PostSevaBooking): Observable<SevaBookingResponse> {

  //   console.log("postSevaBookingParam",postSevaBookingParam)

  //   //this.http.post(url, body, {headers: headers}).subscribe(

  //   let headers1 = new HttpHeaders();
  //   headers1.append('Content-Type', "application/json");
  //   headers1.append('Authorization', localStorage.getItem('token'));
  //   console.log("token: for Authorization",localStorage.getItem('token'))
  //   console.log(headers1)
  //   let postbody = JSON.stringify(postSevaBookingParam);
  //   console.log("postbody",postbody)
  //     return this.httpClient
  //       .post(this.serverURL + 'sevabooking', postSevaBookingParam,{headers: headers1})
  //       .map(
  //         (data) => {
  //           console.log("in postSevaBooking", data);
  //           return <SevaBookingResponse>data;
  //         },
  //         error => {
  //           //console.error();
  //           console.log(error.statusText);
  //         }
  //       );
  //   }


  // public postSevaBooking(postSevaBookingParam: PostSevaBooking): Observable<SevaBookingResponse> {
  //   return this.httpClient
  //     .post(this.serverURL + 'sevabooking', postSevaBookingParam)
  //     .map(
  //       (data) => {
  //         console.log("in postSevaBooking", data);
  //         return <SevaBookingResponse>data;
  //       },
  //       error => {
  //         //console.error();
  //         console.log(error.statusText);
  //       }
  //     );
  // }

  // saURL:string  = "http://45.79.164.165/api/quote/";
  // public postQuotation(id): Observable<string> {
  //   // console.log("getPremium Parameter:"+JSON.stringify(postPremium));
  //   return this.httpClient
  //     .post(this.saURL , id)
  //     .map((data: Response) => {
  //       return data.toString();
  //     },
  //       error => {
  //         console.error();
  //       }
  //     );
  // }






// WEBPACK FOOTER //
// ./src/providers/rest/rest.ts